<template>
  <div>
    <div class="canceled-member__filter">
      <b-checkbox
        v-model="isAllDepartmentSelected"
        native-value="all"
        @input="selectAllDepartments"
      >
        全部 ({{ members.length }})
      </b-checkbox>
      <b-checkbox
        v-for="(info) in sortedDepartmentInfos"
        v-model="selectedDepartments"
        :native-value="info.id"
        :key="info.id"
        @input="departmentChanged"
      >
        {{ getDepartmentName(info.id) }} ({{ info.count }})
      </b-checkbox>
    </div>
    <div class="bg-primary-100 flex items-center px-4 py-2">
      <w-button
        size="func"
        @click="toggleAllDetail = !toggleAllDetail"
      >
        {{ isAllDetailOpened ? '收合詳細內容' : '展開詳細內容' }}
      </w-button>
      <span class="ml-2 text-sm">
        點擊可以一併展開人員訂購品項資訊
      </span>
    </div>
    <b-table
      :data="filteredMembers"
      :opened-detailed="openedRowDetail"
      :row-class="itemRowClass"
      :show-detail-icon="false"
      class="member-table"
      custom-detail-row
      default-sort="name"
      detail-key="id"
      detailed
      hoverable
      scrollable
    >
      <b-table-column
        :th-attrs="columnThAttrs"
        field="index"
        label="No."
        width="28px"
        v-slot="props"
      >
        {{ props.index + 1 }}.
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        field="name"
        label="姓名"
        width="270px"
        sortable
        v-slot="props"
      >
        <div class="flex items-center justify-between p-0">
          {{ props.row.name }}
          <a
            href="#"
            class="text-gray-500"
            @click.prevent="props.toggleDetails(props.row)"
          >
            <font-awesome-icon
              :icon="openedRowDetail.includes(props.row.id) ? 'chevron-up' : 'chevron-down'"
            />
          </a>
        </div>
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        field="account"
        label="帳號"
        width="200px"
        sortable
        v-slot="props"
      >
        {{ props.row.account }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        field="subtotal"
        label="品項總金額"
        sortable
        v-slot="props"
        width="80px"
      >
        {{ props.row.subtotal | commaFormat | priceFormat }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        field="canceled_at"
        label="取消時間"
        width="148px"
        sortable
        v-slot="props"
      >
        {{ cancelAt(props.row.canceled_at) }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        field="cancel_by.name"
        label="取消者"
        width="140px"
        v-slot="props"
      >
        {{ cancelBy(props.row) }}
      </b-table-column>

      <template #detail="props">
        <tr
          v-for="(item, itemIndex) in props.row.member_order_items"
          :key="`member-order-items-${props.index}-${itemIndex}`"
          class="detail-row">
          <td class="detail-row__indicator">&nbsp;</td>
          <td>
            <span class="detail-row__amount">{{ item.quantity || '0' }}</span>
            <span class="detail-row__name">{{ item.entree.name }}</span>
          </td>
          <td colspan="2">
            <span class="detail-row__note leading-6">
              <template v-for="option in sortOptions(item.entree.options)">
                <span
                  v-for="item in option.items"
                  :key="`option-item-${item.index}`"
                  class="
                    mr-1
                    px-[10px]
                    py-[1px]
                    bg-blue-50
                    border
                    border-blue-100
                    rounded-full
                    leading-[22px]
                    whitespace-nowrap
                  "
                >
                  {{ item.name }}{{ item.price ? formatPrice(item.price) : '' }}
                </span>
              </template>
              {{ item.note ? `#${item.note}` : '' }}
            </span>
          </td>
        </tr>
      </template>

      <template #empty>
        <p class="my-12 text-center text-gray-700 text-sm">無已取消訂單</p>
      </template>
    </b-table>
  </div>
</template>

<script>
import CanceledMemberTable from './CanceledMemberTable';

export default CanceledMemberTable;
</script>

<style lang="scss" scoped>
@import "./CanceledMemberTable";
</style>
